import { render, staticRenderFns } from "./OperaLocksWindow.vue?vue&type=template&id=5f1d557f&"
import script from "./OperaLocksWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLocksWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports